// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23FFFFFF%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/imgs/bottom_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/imgs/radial-gradient-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  overflow-y: hidden; }

.bg-main {
  position: relative;
  background-color: var(--bg-primary-dark); }

.nav-text,
.nav-link {
  color: var(--text-primary) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px; }

.main-content {
  margin-top: 40px; }
  .main-content .content-wrapper {
    max-width: 63%; }
  .main-content h1 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 30px; }

.main-list {
  min-height: 800px;
  position: relative; }

.form-label {
  color: white;
  font-size: 16px; }

.form-select {
  border: 2px solid #819396;
  background-color: #202d37;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  cursor: pointer; }

.custom-line {
  min-width: 135px; }

.search-bar {
  height: 40px;
  border-radius: 3px; }

.search-btn {
  --c2: #328ab3;
  --c1: #67bebb;
  background: linear-gradient(90deg, var(--c1), var(--c2) 51%, var(--c1)) var(--x, 0)/200% !important;
  background-size: 200%;
  background-position: 100px 100px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 20px;
  transition: all 0.3s ease-in-out; }
  .search-btn:hover {
    --x: -50%;
    background: linear-gradient(90deg, var(--c1), var(--c2) 51%, var(--c1)) var(--x, 0)/200% !important;
    --c2: #2e7392;
    --c1: #579c9a; }

.task-latest-row .span-background-setup {
  background-color: #28768a;
  border-radius: 5px; }

.task-latest-row .span-background-proof {
  background-color: #2f667c;
  border-radius: 5px; }

.task-latest-row .span-background-deploy {
  background-color: #2d616b;
  border-radius: 5px; }

.task-latest-row .span-color-setup {
  color: #79a197; }

.task-latest-row .span-color-proof {
  color: #ccf2fd; }

.task-latest-row .link-color-hash {
  color: #c9f2e9; }

.task-detail-row {
  padding-bottom: 5px !important;
  padding-top: 8px !important;
  border-bottom: none;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px; }
  .task-detail-row .address-info {
    min-width: 135px; }
  .task-detail-row a {
    text-decoration: none; }
  .task-detail-row a:hover {
    text-decoration: underline; }

.task-detail-row:not(:last-child) {
  border-bottom: 2px solid #34575f !important; }

nav.info-board {
  height: 280px;
  filter: grayscale(70%); }

.main-table {
  position: relative;
  box-shadow: none;
  width: 100%;
  margin: 40px auto;
  margin-bottom: 0;
  --bs-table-accent-bg: transparent;
  border-collapse: separate;
  border-spacing: 0;
  border-bottom: 0px solid transparent;
  border-radius: 15px;
  table-layout: auto; }
  .main-table thead {
    background-color: #2a434e;
    color: white; }
    .main-table thead th {
      padding: 10px 0;
      text-align: center;
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px; }
    .main-table thead th:first-child {
      border-top-left-radius: 15px; }
    .main-table thead th:last-child {
      border-top-right-radius: 15px; }
  .main-table tbody > tr:not(:last-child) {
    border-bottom: 1px solid #263c4b; }
  .main-table tbody > tr:nth-child(even) {
    background-color: #2c3841; }
  .main-table tbody > tr:nth-child(odd) {
    background-color: #232b32; }
  .main-table tbody > tr td:first-child {
    padding-left: 1.5rem; }
  .main-table tbody > tr td:last-child {
    padding-right: 1.5rem; }
  .main-table tbody > tr > td {
    vertical-align: middle;
    text-align: center;
    padding: 6px 20px;
    font-weight: 400;
    font-size: 12px; }
    .main-table tbody > tr > td a.task-id {
      background-color: #384c63;
      color: #dbebff;
      padding: 5px 10px;
      border-radius: 5px;
      text-decoration: none; }
      .main-table tbody > tr > td a.task-id:hover {
        text-decoration: underline;
        color: white; }
    .main-table tbody > tr > td a.tx-hash {
      background-color: #324b54;
      color: #dbebff;
      padding: 5px 10px;
      border-radius: 5px;
      text-decoration: none; }
      .main-table tbody > tr > td a.tx-hash:hover {
        text-decoration: underline;
        color: white; }
    .main-table tbody > tr > td.min-width-lg {
      min-width: 350px; }
    .main-table tbody > tr > td.min-width-md {
      min-width: 250px; }
    .main-table tbody > tr > td.min-width-sm {
      min-width: 100px; }
    .main-table tbody > tr > td.min-width-xs {
      min-width: 50px; }
    .main-table tbody > tr > td.td-address {
      color: #51bdfb; }
      .main-table tbody > tr > td.td-address a {
        color: #51bdfb; }
    .main-table tbody > tr > td.td-info {
      color: #dbebff; }
    .main-table tbody > tr > td.min-height-30 {
      min-height: 30px; }
    .main-table tbody > tr > td.min-height-50 {
      min-height: 50px; }
    .main-table tbody > tr > td .task-success-badge {
      font-family: MyriadPro;
      box-sizing: border-box;
      background-color: #3e8166;
      color: #afefd2;
      padding: 5px 0;
      border-radius: 5px;
      max-width: 75px;
      margin: auto; }
    .main-table tbody > tr > td .task-fail-badge {
      font-family: MyriadPro;
      box-sizing: border-box;
      background-color: #dd6b00;
      color: #ffcea0;
      padding: 5px 0;
      border-radius: 5px;
      max-width: 75px;
      margin: auto; }
    .main-table tbody > tr > td .task-pending-badge {
      font-family: MyriadPro;
      background-color: #ca9b00;
      color: #fff59a;
      padding: 5px 0;
      border-radius: 5px;
      max-width: 75px;
      margin: auto; }
    .main-table tbody > tr > td .task-dryrunfail-badge {
      font-family: MyriadPro;
      background-color: #ca9b00;
      color: #fff59a;
      padding: 5px 0;
      border-radius: 5px;
      max-width: 75px;
      margin: auto; }
    .main-table tbody > tr > td .task-unprovable-badge {
      font-family: MyriadPro;
      background-color: #894e50;
      color: #fabcbc;
      padding: 5px 0;
      border-radius: 5px;
      max-width: 75px;
      margin: auto; }
    .main-table tbody > tr > td .task-stale-badge {
      font-family: MyriadPro;
      background-color: #636363;
      color: #dadada;
      padding: 5px 0;
      border-radius: 5px;
      max-width: 75px;
      margin: auto; }

.table-container {
  position: relative; }

.table-heading {
  color: #ade2e9;
  font-weight: 600;
  font-size: 16px;
  margin-top: 25px;
  margin-bottom: 10px; }

.batch-status-pending {
  color: #ba9a5b !important; }

.batch-status-batched {
  color: #2ccf95 !important; }

.more-button {
  background-color: #427d96;
  border-radius: 5px;
  padding: 5px 10px;
  color: #8de5e2;
  font-weight: 400;
  font-size: 12px;
  transition: all 0.3s;
  cursor: pointer; }
  .more-button:hover {
    color: white; }

.pagination-wrapper {
  height: 50px;
  background-color: #2a434e;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px; }

.pagination {
  margin-bottom: 0;
  margin-right: 1.5rem; }
  .pagination .page-item.active .page-link {
    background-image: none;
    background-color: transparent;
    padding-left: 15px;
    padding-right: 15px;
    font-weight: 400;
    font-size: 12px; }
    .pagination .page-item.active .page-link:hover {
      background-color: transparent !important;
      background-image: none; }
  .pagination .page-link {
    --bs-pagination-border-radius: 5px;
    background-image: none;
    font-size: 20px;
    line-height: 24px;
    padding: 0 5px;
    background-color: #37656f;
    border: none;
    vertical-align: middle !important;
    text-align: center;
    min-width: 35px; }
    .pagination .page-link:hover {
      background-color: #3c7378 !important;
      background-image: none; }
  .pagination .page-item {
    border-radius: 5px; }

.divider-up {
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #272727; }

.form-check-input:checked {
  background-color: #40ccc9;
  border-color: #40ccc9; }

.navbar {
  border: none;
  font-weight: 400;
  font-size: 12px; }
  .navbar .nav-container {
    max-width: 100%;
    padding-left: 18px;
    padding-right: 18px; }
  .navbar .dropdown-menu {
    background-color: #1f262d;
    border: 2px solid #ade2e9; }
    .navbar .dropdown-menu .dropdown-item {
      padding: 2px 8px;
      color: #ade2e9;
      font-weight: 400;
      font-size: 12px; }
      .navbar .dropdown-menu .dropdown-item .bi-trash:hover {
        color: white; }
    .navbar .dropdown-menu .dropdown-divider {
      border-top: 2px solid #ade2e9;
      width: 90%;
      margin-left: auto;
      margin-right: auto; }
  .navbar .connect-account {
    font-weight: 400;
    font-size: 10px;
    border: 1px solid #a3a6a9 !important;
    border-radius: 5px;
    cursor: pointer;
    padding: 5px 10px;
    transition: all 0.3s; }
    .navbar .connect-account:hover {
      background-color: #464646; }
  .navbar .account-info {
    color: #ade2e9;
    font-size: 0.9em;
    margin-left: 10px;
    transition: 0.2s all; }
    .navbar .account-info:hover {
      color: var(--bs-gray-300); }
    .navbar .account-info .circle-surround {
      border-radius: 50%;
      border: 1px solid #8de5e2;
      width: 18px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center; }
    .navbar .account-info .balance-info .label:hover {
      color: #8de5e2 !important; }
    .navbar .account-info .balance-info .amount {
      font-weight: 400;
      font-size: 10px; }
  .navbar .navbar-brand {
    padding: 5px 0; }
  .navbar .nav-link {
    border: none;
    padding: 0.25rem 0.5rem; }
    .navbar .nav-link a {
      color: var(--bs-gray-600) !important;
      transition: all 0.2s ease-in-out; }
    .navbar .nav-link:hover, .navbar .nav-link:focus {
      border: none !important;
      background-image: none;
      color: var(--bs-gray-300) !important; }
      .navbar .nav-link:hover a, .navbar .nav-link:focus a {
        color: var(--bs-gray-300) !important; }

.toast .toast-header {
  color: white;
  background-color: green; }

.toast .toast-body {
  color: white; }

footer.footer {
  margin-top: 40px;
  border-top: 1px solid gray;
  border-top: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #94c4ca; }
  footer.footer .container {
    padding-bottom: 40px;
    padding: 10px 0; }
    footer.footer .container .row {
      margin-right: 0;
      margin-left: 0; }
  footer.footer a {
    color: #94c4ca;
    text-decoration: none; }
    footer.footer a:hover {
      cursor: pointer;
      text-decoration: underline; }
  footer.footer .footer-pill {
    border-radius: 50px;
    padding: 15px 0;
    padding-left: 25px;
    padding-right: 15px;
    background-image: linear-gradient(90deg, #326463 0%, #204159 100%); }
    footer.footer .footer-pill .more-pill {
      font-weight: 600;
      font-size: 10px;
      background: #94c4ca;
      border-radius: 25px;
      color: #1f353f;
      padding: 5px 20px;
      transition: all 0.3s;
      text-decoration: none; }
      footer.footer .footer-pill .more-pill:hover {
        color: white; }
  footer.footer .main-links {
    margin-top: 40px; }
    footer.footer .main-links .logo {
      display: block;
      height: 35px;
      width: 126px; }
    footer.footer .main-links .sub-heading {
      font-style: normal;
      font-weight: 500;
      font-size: 14px; }
    footer.footer .main-links .link {
      font-weight: 500;
      font-size: 12px;
      text-decoration-line: underline;
      color: #729ba2;
      padding-top: 2px;
      padding-bottom: 2px; }
    footer.footer .main-links .integration-wrapper {
      margin-left: 5%;
      margin-right: 10%;
      width: 90%; }
    footer.footer .main-links .socials {
      align-self: flex-start; }
      footer.footer .main-links .socials img {
        width: 40px;
        height: 40px;
        margin-right: 20px; }
  footer.footer .footer-heading {
    vertical-align: middle;
    font-weight: 600;
    font-size: 14px;
    color: #94c4ca; }
  footer.footer .footer-heading-info {
    font-weight: 400;
    font-size: 12px; }
  footer.footer .media-name {
    font-weight: 700;
    font-size: 20px;
    line-height: 31px; }
  footer.footer .copyright {
    margin-top: 20px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #729ba2; }

.img-bg {
  position: absolute !important;
  z-index: 0 !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 100% auto; }
`, "",{"version":3,"sources":["webpack://./src/layout/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,wCAAwC,EAAA;;AAG1C;;EAEE,qCAAqC;EACrC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;;AAEjB;EACE,gBAAgB,EAAA;EADlB;IAGI,cAAc,EAAA;EAHlB;IAMI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAA;;AAGnB;EACE,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yDAAiR;EACjR,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;;AAGlB;EACE,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,aAAK;EACL,aAAK;EAEL,mGAC+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC,EAAA;EAZlC;IAeI,SAAI;IAEJ,mGAC+B;IAC/B,aAAK;IACL,aAAK,EAAA;;AAIT;EAEI,yBAAyB;EACzB,kBAAkB,EAAA;;AAHtB;EAOI,yBAAyB;EACzB,kBAAkB,EAAA;;AARtB;EAYI,yBAAyB;EACzB,kBAAkB,EAAA;;AAbtB;EAiBI,cAAc,EAAA;;AAjBlB;EAqBI,cAAc,EAAA;;AArBlB;EAyBI,cAAc,EAAA;;AAIlB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;EAPjB;IAUI,gBAAgB,EAAA;EAVpB;IAaI,qBAAqB,EAAA;EAbzB;IAgBI,0BAA0B,EAAA;;AAG9B;EACE,2CAA2C,EAAA;;AAG7C;EACE,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iCAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,oCAAoC;EAEpC,mBAAmB;EACnB,kBAAkB,EAAA;EAZpB;IAcI,yBAAyB;IACzB,YAAY,EAAA;IAfhB;MAkBM,eAAe;MACf,kBAAkB;MAClB,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe,EAAA;IAvBrB;MA0BM,4BAA4B,EAAA;IA1BlC;MA6BM,6BAA6B,EAAA;EA7BnC;IAmCM,gCAAgC,EAAA;EAnCtC;IAuCM,yBAAyB,EAAA;EAvC/B;IA0CM,yBAAyB,EAAA;EA1C/B;IAiDM,oBAAoB,EAAA;EAjD1B;IAoDM,qBAAqB,EAAA;EApD3B;IAyDI,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe,EAAA;IA7DnB;MA+DM,yBAAyB;MACzB,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB,EAAA;MAnE3B;QAsEQ,0BAA0B;QAC1B,YAAY,EAAA;IAvEpB;MA2EM,yBAAyB;MACzB,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,qBAAqB,EAAA;MA/E3B;QAiFQ,0BAA0B;QAC1B,YAAY,EAAA;IAlFpB;MAsFM,gBAAgB,EAAA;IAtFtB;MAyFM,gBAAgB,EAAA;IAzFtB;MA4FM,gBAAgB,EAAA;IA5FtB;MA+FM,eAAe,EAAA;IA/FrB;MAkGM,cAAc,EAAA;MAlGpB;QAoGQ,cAAc,EAAA;IApGtB;MAwGM,cAAc,EAAA;IAxGpB;MA4GM,gBAAgB,EAAA;IA5GtB;MA+GM,gBAAgB,EAAA;IA/GtB;MAkHM,sBAAsB;MACtB,sBAAsB;MACtB,yBAAyB;MACzB,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,YAAY,EAAA;IAzHlB;MA4HM,sBAAsB;MACtB,sBAAsB;MACtB,yBAAyB;MACzB,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,YAAY,EAAA;IAnIlB;MAsIM,sBAAsB;MACtB,yBAAyB;MACzB,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,YAAY,EAAA;IA5IlB;MA+IM,sBAAsB;MACtB,yBAAyB;MACzB,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,YAAY,EAAA;IArJlB;MAwJM,sBAAsB;MACtB,yBAAyB;MACzB,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,YAAY,EAAA;IA9JlB;MAiKM,sBAAsB;MACtB,yBAAyB;MACzB,cAAc;MACd,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,YAAY,EAAA;;AAIlB;EACE,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe,EAAA;EARjB;IAUI,YAAY,EAAA;;AAGhB;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC,EAAA;;AAMlC;EACE,gBAAgB;EAChB,oBAAoB,EAAA;EAFtB;IAII,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IAEnB,gBAAgB;IAChB,eAAe,EAAA;IAVnB;MAaM,wCAAwC;MACxC,sBAAsB,EAAA;EAd5B;IAkBI,kCAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,cAAc;IAEd,yBAAyB;IACzB,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,eAAe,EAAA;IA5BnB;MA8BM,oCAAoC;MACpC,sBAAsB,EAAA;EA/B5B;IAmCI,kBAAkB,EAAA;;AAItB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B,EAAA;;AAG/B;EACE,yBAAyB;EACzB,qBAAqB,EAAA;;AAEvB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe,EAAA;EAHjB;IAKI,eAAe;IACf,kBAAkB;IAClB,mBAAmB,EAAA;EAPvB;IAWI,yBAAyB;IACzB,yBAAyB,EAAA;IAZ7B;MAcM,gBAAgB;MAChB,cAAc;MACd,gBAAgB;MAChB,eAAe,EAAA;MAjBrB;QAoBU,YAAY,EAAA;IApBtB;MAyBM,6BAA6B;MAC7B,UAAU;MACV,iBAAiB;MACjB,kBAAkB,EAAA;EA5BxB;IAiCI,gBAAgB;IAChB,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oBAAoB,EAAA;IAvCxB;MAyCM,yBAAyB,EAAA;EAzC/B;IA8CI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB,EAAA;IAjDxB;MAmDM,yBAAyB,EAAA;IAnD/B;MAuDM,kBAAkB;MAClB,yBAAyB;MACzB,WAAW;MACX,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;IA7DzB;MAkEU,yBAAyB,EAAA;IAlEnC;MAsEQ,gBAAgB;MAChB,eAAe,EAAA;EAvEvB;IA4EI,cAAc,EAAA;EA5ElB;IA+EI,YAAY;IACZ,uBAAuB,EAAA;IAhF3B;MAkFM,oCAAoC;MACpC,gCAAgC,EAAA;IAnFtC;MAuFM,uBAAuB;MACvB,sBAAsB;MACtB,oCAAoC,EAAA;MAzF1C;QA2FQ,oCAAoC,EAAA;;AAM5C;EAEI,YAAY;EACZ,uBAAuB,EAAA;;AAH3B;EAMI,YAAY,EAAA;;AAIhB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,yDAAqD;EACrD,4BAA4B;EAC5B,0BAA0B;EAE1B,cAAc,EAAA;EARhB;IAUI,oBAAoB;IACpB,eAAe,EAAA;IAXnB;MAaM,eAAe;MACf,cAAc,EAAA;EAdpB;IAkBI,cAAc;IACd,qBAAqB,EAAA;IAnBzB;MAqBM,eAAe;MACf,0BAA0B,EAAA;EAtBhC;IA0BI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kEAKC,EAAA;IAnCL;MAsCM,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,mBAAmB;MACnB,cAAc;MACd,iBAAiB;MACjB,oBAAoB;MACpB,qBAAqB,EAAA;MA7C3B;QA+CQ,YAAY,EAAA;EA/CpB;IAoDI,gBAAgB,EAAA;IApDpB;MAuDM,cAAc;MAEd,YAAY;MACZ,YAAY,EAAA;IA1DlB;MA6DM,kBAAkB;MAClB,gBAAgB;MAChB,eAAe,EAAA;IA/DrB;MAkEM,gBAAgB;MAChB,eAAe;MACf,+BAA+B;MAC/B,cAAc;MACd,gBAAgB;MAChB,mBAAmB,EAAA;IAvEzB;MA0EM,eAAe;MACf,iBAAiB;MACjB,UAAU,EAAA;IA5EhB;MA+EM,sBAAsB,EAAA;MA/E5B;QAiFQ,WAAW;QACX,YAAY;QACZ,kBAAkB,EAAA;EAnF1B;IAwFI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IAEf,cAAc,EAAA;EA5FlB;IA+FI,gBAAgB;IAChB,eAAe,EAAA;EAhGnB;IAmGI,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EArGrB;IAwGI,gBAAgB;IAEhB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAA;;AAIlB;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAA8D;EAC9D,4BAA4B;EAC5B,0BAA0B,EAAA","sourcesContent":["#root {\n  overflow-y: hidden;\n}\n\n.bg-main {\n  position: relative;\n  background-color: var(--bg-primary-dark);\n}\n\n.nav-text,\n.nav-link {\n  color: var(--text-primary) !important;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n}\n.main-content {\n  margin-top: 40px;\n  .content-wrapper {\n    max-width: 63%;\n  }\n  h1 {\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 30px;\n  }\n}\n.main-list {\n  min-height: 800px;\n  position: relative;\n}\n\n.form-label {\n  color: white;\n  font-size: 16px;\n}\n\n.form-select {\n  border: 2px solid #819396;\n  background-color: #202d37;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23FFFFFF%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e\");\n  color: white;\n  cursor: pointer;\n}\n\n.custom-line {\n  min-width: 135px;\n}\n\n.search-bar {\n  height: 40px;\n  border-radius: 3px;\n}\n\n.search-btn {\n  --c2: #328ab3;\n  --c1: #67bebb;\n\n  background: linear-gradient(90deg, var(--c1), var(--c2) 51%, var(--c1))\n    var(--x, 0) / 200% !important;\n  background-size: 200%;\n  background-position: 100px 100px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 10px 20px;\n  transition: all 0.3s ease-in-out;\n\n  &:hover {\n    --x: -50%;\n\n    background: linear-gradient(90deg, var(--c1), var(--c2) 51%, var(--c1))\n      var(--x, 0) / 200% !important;\n    --c2: #2e7392;\n    --c1: #579c9a;\n  }\n}\n\n.task-latest-row {\n  .span-background-setup {\n    background-color: #28768a;\n    border-radius: 5px;\n  }\n\n  .span-background-proof {\n    background-color: #2f667c;\n    border-radius: 5px;\n  }\n\n  .span-background-deploy {\n    background-color: #2d616b;\n    border-radius: 5px;\n  }\n\n  .span-color-setup {\n    color: #79a197;\n  }\n\n  .span-color-proof {\n    color: #ccf2fd;\n  }\n\n  .link-color-hash {\n    color: #c9f2e9;\n  }\n}\n\n.task-detail-row {\n  padding-bottom: 5px !important;\n  padding-top: 8px !important;\n  border-bottom: none;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n\n  .address-info {\n    min-width: 135px;\n  }\n  a {\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n}\n.task-detail-row:not(:last-child) {\n  border-bottom: 2px solid #34575f !important;\n}\n\nnav.info-board {\n  height: 280px;\n  filter: grayscale(70%);\n}\n\n.main-table {\n  position: relative;\n  box-shadow: none;\n  width: 100%;\n  margin: 40px auto;\n  margin-bottom: 0;\n  --bs-table-accent-bg: transparent;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-bottom: 0px solid transparent;\n  //border-bottom: 50px solid #2a434e; // The color of your choosing for the outer border\n  border-radius: 15px;\n  table-layout: auto;\n  thead {\n    background-color: #2a434e;\n    color: white;\n\n    th {\n      padding: 10px 0;\n      text-align: center;\n      font-family: \"Inter\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n    }\n    th:first-child {\n      border-top-left-radius: 15px;\n    }\n    th:last-child {\n      border-top-right-radius: 15px;\n    }\n  }\n\n  tbody > tr {\n    &:not(:last-child) {\n      border-bottom: 1px solid #263c4b;\n    }\n\n    &:nth-child(even) {\n      background-color: #2c3841;\n    }\n    &:nth-child(odd) {\n      background-color: #232b32;\n    }\n  }\n\n  tbody > tr {\n    //first child and last TD in each row should have equal margins to the ends\n    td:first-child {\n      padding-left: 1.5rem;\n    }\n    td:last-child {\n      padding-right: 1.5rem;\n    }\n  }\n\n  tbody > tr > td {\n    vertical-align: middle;\n    text-align: center;\n    padding: 6px 20px;\n    font-weight: 400;\n    font-size: 12px;\n    a.task-id {\n      background-color: #384c63;\n      color: #dbebff;\n      padding: 5px 10px;\n      border-radius: 5px;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n        color: white;\n      }\n    }\n    a.tx-hash {\n      background-color: #324b54;\n      color: #dbebff;\n      padding: 5px 10px;\n      border-radius: 5px;\n      text-decoration: none;\n      &:hover {\n        text-decoration: underline;\n        color: white;\n      }\n    }\n    &.min-width-lg {\n      min-width: 350px;\n    }\n    &.min-width-md {\n      min-width: 250px;\n    }\n    &.min-width-sm {\n      min-width: 100px;\n    }\n    &.min-width-xs {\n      min-width: 50px;\n    }\n    &.td-address {\n      color: #51bdfb;\n      a {\n        color: #51bdfb;\n      }\n    }\n    &.td-info {\n      color: #dbebff;\n    }\n\n    &.min-height-30 {\n      min-height: 30px;\n    }\n    &.min-height-50 {\n      min-height: 50px;\n    }\n    .task-success-badge {\n      font-family: MyriadPro;\n      box-sizing: border-box;\n      background-color: #3e8166;\n      color: #afefd2;\n      padding: 5px 0;\n      border-radius: 5px;\n      max-width: 75px;\n      margin: auto;\n    }\n    .task-fail-badge {\n      font-family: MyriadPro;\n      box-sizing: border-box;\n      background-color: #dd6b00;\n      color: #ffcea0;\n      padding: 5px 0;\n      border-radius: 5px;\n      max-width: 75px;\n      margin: auto;\n    }\n    .task-pending-badge {\n      font-family: MyriadPro;\n      background-color: #ca9b00;\n      color: #fff59a;\n      padding: 5px 0;\n      border-radius: 5px;\n      max-width: 75px;\n      margin: auto;\n    }\n    .task-dryrunfail-badge {\n      font-family: MyriadPro;\n      background-color: #ca9b00;\n      color: #fff59a;\n      padding: 5px 0;\n      border-radius: 5px;\n      max-width: 75px;\n      margin: auto;\n    }\n    .task-unprovable-badge {\n      font-family: MyriadPro;\n      background-color: #894e50;\n      color: #fabcbc;\n      padding: 5px 0;\n      border-radius: 5px;\n      max-width: 75px;\n      margin: auto;\n    }\n    .task-stale-badge {\n      font-family: MyriadPro;\n      background-color: #636363;\n      color: #dadada;\n      padding: 5px 0;\n      border-radius: 5px;\n      max-width: 75px;\n      margin: auto;\n    }\n  }\n}\n.table-container {\n  position: relative;\n}\n\n.table-heading {\n  color: #ade2e9;\n  font-weight: 600;\n  font-size: 16px;\n  margin-top: 25px;\n  margin-bottom: 10px;\n}\n\n.batch-status-pending {\n  color: #ba9a5b !important;\n}\n\n.batch-status-batched {\n  color: #2ccf95 !important;\n}\n\n.more-button {\n  background-color: #427d96;\n  border-radius: 5px;\n  padding: 5px 10px;\n  color: #8de5e2;\n  font-weight: 400;\n  font-size: 12px;\n  transition: all 0.3s;\n  cursor: pointer;\n  &:hover {\n    color: white;\n  }\n}\n.pagination-wrapper {\n  height: 50px;\n  background-color: #2a434e;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  // position: absolute;\n  // bottom: -5px; /* Adjust this value to match the thickness of the border */\n  // right: 10px;\n}\n\n.pagination {\n  margin-bottom: 0;\n  margin-right: 1.5rem;\n  .page-item.active .page-link {\n    background-image: none;\n    background-color: transparent;\n    padding-left: 15px;\n    padding-right: 15px;\n\n    font-weight: 400;\n    font-size: 12px;\n\n    &:hover {\n      background-color: transparent !important;\n      background-image: none;\n    }\n  }\n  .page-link {\n    --bs-pagination-border-radius: 5px;\n    background-image: none;\n    font-size: 20px;\n    line-height: 24px;\n    padding: 0 5px;\n\n    background-color: #37656f;\n    border: none;\n    vertical-align: middle !important;\n    text-align: center;\n    min-width: 35px;\n    &:hover {\n      background-color: #3c7378 !important;\n      background-image: none;\n    }\n  }\n  .page-item {\n    border-radius: 5px;\n  }\n}\n\n.divider-up {\n  padding-top: 10px;\n  margin-top: 10px;\n  border-top: 1px solid #272727;\n}\n\n.form-check-input:checked {\n  background-color: #40ccc9;\n  border-color: #40ccc9;\n}\n.navbar {\n  border: none;\n  font-weight: 400;\n  font-size: 12px;\n  .nav-container {\n    max-width: 100%;\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .dropdown-menu {\n    background-color: #1f262d;\n    border: 2px solid #ade2e9;\n    .dropdown-item {\n      padding: 2px 8px;\n      color: #ade2e9;\n      font-weight: 400;\n      font-size: 12px;\n      .bi-trash {\n        &:hover {\n          color: white;\n        }\n      }\n    }\n    .dropdown-divider {\n      border-top: 2px solid #ade2e9;\n      width: 90%;\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n\n  .connect-account {\n    font-weight: 400;\n    font-size: 10px;\n    border: 1px solid #a3a6a9 !important;\n    border-radius: 5px;\n    cursor: pointer;\n    padding: 5px 10px;\n    transition: all 0.3s;\n    &:hover {\n      background-color: #464646;\n    }\n  }\n\n  .account-info {\n    color: #ade2e9;\n    font-size: 0.9em;\n    margin-left: 10px;\n    transition: 0.2s all;\n    &:hover {\n      color: var(--bs-gray-300);\n    }\n\n    .circle-surround {\n      border-radius: 50%;\n      border: 1px solid #8de5e2;\n      width: 18px;\n      height: 18px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .balance-info {\n      .label {\n        &:hover {\n          color: #8de5e2 !important;\n        }\n      }\n      .amount {\n        font-weight: 400;\n        font-size: 10px;\n      }\n    }\n  }\n  .navbar-brand {\n    padding: 5px 0;\n  }\n  .nav-link {\n    border: none;\n    padding: 0.25rem 0.5rem;\n    a {\n      color: var(--bs-gray-600) !important;\n      transition: all 0.2s ease-in-out;\n    }\n    &:hover,\n    &:focus {\n      border: none !important;\n      background-image: none;\n      color: var(--bs-gray-300) !important;\n      a {\n        color: var(--bs-gray-300) !important;\n      }\n    }\n  }\n}\n\n.toast {\n  .toast-header {\n    color: white;\n    background-color: green;\n  }\n  .toast-body {\n    color: white;\n  }\n}\n\nfooter.footer {\n  margin-top: 40px;\n  border-top: 1px solid gray;\n  border-top: none;\n  background-image: url(\"../assets/imgs/bottom_bg.png\");\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n\n  color: #94c4ca;\n  .container {\n    padding-bottom: 40px;\n    padding: 10px 0;\n    .row {\n      margin-right: 0;\n      margin-left: 0;\n    }\n  }\n  a {\n    color: #94c4ca;\n    text-decoration: none;\n    &:hover {\n      cursor: pointer;\n      text-decoration: underline;\n    }\n  }\n  .footer-pill {\n    border-radius: 50px;\n    padding: 15px 0;\n    padding-left: 25px;\n    padding-right: 15px;\n    background-image: linear-gradient(\n      90deg,\n      #326463 0%,\n\n      #204159 100%\n    );\n\n    .more-pill {\n      font-weight: 600;\n      font-size: 10px;\n      background: #94c4ca;\n      border-radius: 25px;\n      color: #1f353f;\n      padding: 5px 20px;\n      transition: all 0.3s;\n      text-decoration: none;\n      &:hover {\n        color: white;\n      }\n    }\n  }\n  .main-links {\n    margin-top: 40px;\n\n    .logo {\n      display: block;\n\n      height: 35px;\n      width: 126px;\n    }\n    .sub-heading {\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n    }\n    .link {\n      font-weight: 500;\n      font-size: 12px;\n      text-decoration-line: underline;\n      color: #729ba2;\n      padding-top: 2px;\n      padding-bottom: 2px;\n    }\n    .integration-wrapper {\n      margin-left: 5%;\n      margin-right: 10%;\n      width: 90%;\n    }\n    .socials {\n      align-self: flex-start;\n      img {\n        width: 40px;\n        height: 40px;\n        margin-right: 20px;\n      }\n    }\n  }\n  .footer-heading {\n    vertical-align: middle;\n    font-weight: 600;\n    font-size: 14px;\n\n    color: #94c4ca;\n  }\n  .footer-heading-info {\n    font-weight: 400;\n    font-size: 12px;\n  }\n  .media-name {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 31px;\n  }\n  .copyright {\n    margin-top: 20px;\n\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    color: #729ba2;\n  }\n}\n\n.img-bg {\n  position: absolute !important;\n  z-index: 0 !important;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"../assets/imgs/radial-gradient-bg.png\");\n  background-repeat: no-repeat;\n  background-size: 100% auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
